import React, {
  FC, useCallback, useEffect, useState,
} from 'react';
import clsx from 'clsx';
import Pressable from './Pressable';

interface ToggleProps {
  value?: boolean;
  className?: string;
  onChange?: () => void;
  color?: 'default' | 'primary' | 'secondary';
  disabled?: boolean;
}

const Toggle: FC<ToggleProps> = ({
  value, className, onChange, color = 'default', disabled,
}) => {
  const [v, setV] = useState(value);

  const cls = {
    toggle: true,
    active: v,
    'toggle--primary': color === 'primary',
    'toggle--secondary': color === 'secondary',
  };

  const handle = useCallback(() => {
    setV((old) => !old);
    if (onChange) {
      onChange();
    }
  }, [onChange]);

  useEffect(() => {
    setV(value);
  }, [value]);

  return (
    <Pressable
      className={clsx(cls, className)}
      onClick={handle}
      disabled={disabled}
    />
  );
};

export default Toggle;
